import { render, staticRenderFns } from "./UpdateBulkOrder.vue?vue&type=template&id=589382e5&scoped=true"
import script from "./UpdateBulkOrder.vue?vue&type=script&lang=js"
export * from "./UpdateBulkOrder.vue?vue&type=script&lang=js"
import style0 from "./UpdateBulkOrder.vue?vue&type=style&index=0&id=589382e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589382e5",
  null
  
)

export default component.exports